import React from 'react';
import { string, func, bool, object, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import { Consumer } from 'components/Banner/HeroBanner/HeroWrapper/HeroWrapper';
import { withMediaQuery } from 'common/utils';
import { getButtonsArray } from 'components/Banner/HeroBanner/utils';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Button from 'elements/Buttons/Button';
import ActionIcon from 'elements/ActionIcons/ActionIcon';

import styles from './TypeA.css';

const cx = classnames.bind(styles);

const TypeA = ({
  colorScheme,
  className,
  label,
  title,
  highlighted,
  description,
  link,
  button,
  onClick,
  v2,
  right,
  withPlayer
}) => {
  const buttonsArray = button && getButtonsArray(button, onClick, styles.button);

  return (
    <Consumer>
      {({ playVideo }) => (
        <div className={cx('container', colorScheme, className, { 'v2': v2, 'right': right })}>
          <div className={styles.wrapper}>
            <p className={styles.label}>{label}</p>
            <h5 className={styles.title}>
              {highlighted && <span className={styles.highlight}>{highlighted} </span>}
              {title}
            </h5>
            <p className={styles.description}>
              {description}
            </p>
            {/* TODO: include right icon when its available on the library */}
            {
              withPlayer &&
                <ActionIcon
                  customClasses={styles.playIcon}
                  icon="play"
                  type="80"
                  onClick={playVideo}
                  responsive />
            }
            {
              link &&
                <LinkFreeStanding
                  className={styles.link}
                  icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
                  size="m"
                  dark={colorScheme === 'pb01' || colorScheme === 'pb02'}
                  withBouncing
                  onClick={onClick}
                >
                  {link}
                </LinkFreeStanding>
            }
            {button && withMediaQuery(Button, buttonsArray)}
          </div>
        </div>
      )}
    </Consumer>
  );
};

TypeA.propTypes = {
  colorScheme: oneOf(['lb01', 'lb02', 'pb01', 'pb02']),
  button: object,
  className: string,
  label: string,
  highlighted: string,
  title: string.isRequired,
  description: string.isRequired,
  link: string,
  onClick: func.isRequired,
  v2: bool,
  right: bool,
  withPlayer: bool
};

TypeA.defaultProps = {
  colorScheme: 'lb01'
};

TypeA.displayName = 'TypeA';

export default TypeA;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeA/TypeA.js